var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2314 1.08223C13.9672 0.817967 13.5388 0.817967 13.2745 1.08223L5.16773 9.18907L2.05162 6.07297C1.78738 5.8087 1.35898 5.80873 1.09468 6.07297C0.830418 6.33721 0.830418 6.76561 1.09468 7.02988L4.68926 10.6244C4.95342 10.8886 5.38214 10.8885 5.6462 10.6244L14.2314 2.03917C14.4957 1.77493 14.4957 1.3465 14.2314 1.08223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7a450e986150536e2a8b8a9cba3d235f.svg";
export { ForwardRef as ReactComponent };